import React from "react";

const CreditDepositEntry = () => {
  return (
    <div className="page-content">
      <div className="container-fluid">
        <h2>CreditDepositEntry</h2>
        <p>Content for CreditDepositEntry page will go here.</p>
      </div>
    </div>
  );
};

export default CreditDepositEntry;
